import { catchError, map, mergeMap, tap } from "rxjs/operators";
import { Epic, ofType } from "redux-observable";
import { concat, of } from "rxjs";
import { RootState } from "../../store";
import * as organizationActions from "./organizationActions";
import * as authSelectors from "../auth/authSelectors";
import { ServiceContainer } from "../../serviceContainer";
import { AjaxError } from "rxjs/ajax";

export const updateUISettings: Epic<any, any, RootState, ServiceContainer> = (
  action$,
  state$,
  services
) =>
  action$.pipe(
    ofType(organizationActions.UPSERT_UI_SETTINGS),
    mergeMap((action: organizationActions.UpsertUISettingsAction) => {
      const state = state$.value;
      return services.apiOrganization
        .setUISettings(
          authSelectors.accessToken(state),
          action.organization,
          action.data
        )
        .pipe(
          tap(() =>
            services.toastr.success(
              "Success",
              "Organization UI Settings were updated"
            )
          ),
          mergeMap(() =>
            concat(
              of(
                organizationActions.upsertUISettingsSuccess(action.organization)
              ),
              services.apiOrganization
                .getUISettings(
                  authSelectors.accessToken(state),
                  action.organization
                )
                .pipe(
                  map((uiSettings) =>
                    organizationActions.getUISettingsSuccess(
                      action.organization,
                      uiSettings
                    )
                  )
                )
            )
          ),
          catchError((x: AjaxError) => {
            if (
              x.status === 400 &&
              x.xhr.response.errors &&
              x.xhr.response.errors.length
            ) {
              services.toastr.warning(
                "Warning",
                `Some values in the form are invalid`
              );
              return of(
                organizationActions.upsertUISettingsFail(
                  action.organization,
                  x.xhr.response.errors
                )
              );
            } else {
              services.toastr.error(
                "Error",
                `There was problem with updating the settings`
              );

              return of(
                organizationActions.upsertUISettingsFail(
                  action.organization,
                  x.xhr.response.errors
                )
              );
            }
          })
        );
    })
  );
